

import React from "react";
import { Link } from "react-router-dom";
import video from '../../assets/Ayurveda.mp4';

const HomeSlider: React.FC = () => {
  // SEO Optimized Content
  // Keywords injected: Ayurvedic Medicine, Herbal Products, Natural Remedies, Immunity Boosters
  const content = {
    title: "Ayush Vatika - Best Ayurvedic & Herbal Products",
    subtitle: "Explore authentic natural remedies, immunity boosters, and traditional care delivered to your doorstep.",
    link: "/explore-ayushvatika", 
    buttonText: "EXPLORE AYUSHVATIKA",
  };

  return (
    <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] overflow-hidden">
      {/* Background Video */}
      <video
        className="absolute inset-0 h-full w-full object-cover"
        src={video}
        autoPlay
        loop
        muted
        playsInline
        // SEO: Title added for accessibility
        title="Ayurvedic herbal medicine preparation background video"
      />

      {/* Overlay for contrast */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Main content block, now centered */}
      <div className="container mx-auto relative h-full flex items-center justify-center p-4">
        <div className="relative text-center text-white p-8">
          {/* Title - H1 Tag is crucial for SEO (Primary Keywords here) */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold font-serif leading-tight mb-4 drop-shadow-lg animate-fade-in-up">
            {content.title}
          </h1>

          {/* Subtitle - Includes LSI/Secondary Keywords */}
          <p className="text-lg sm:text-xl md:text-2xl font-light mb-8 drop-shadow-md animate-fade-in max-w-3xl mx-auto">
            {content.subtitle}
          </p>

          {/* Action Button - Improved CTA */}
          <Link 
            to={content.link} 
            className="bg-white text-green-700 px-8 py-3 rounded-full font-semibold text-lg hover:bg-green-100 transition-colors duration-300 transform hover:scale-105 animate-fade-in-up delay-100 inline-block"
            aria-label="Explore our range of Ayurvedic and Herbal products"
          >
            {content.buttonText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeSlider;